import RecentDeployments from './deployments';
import ProfileBox from './profileBox';
import RecentPost from './recentPost';
import classes from './SideBar.module.css';
const SideBar =()=>{
    return(
        <>
        <div className={classes.SideBarLayout}>
        <ProfileBox/>
        <RecentDeployments/>
        <RecentPost/>
        </div>
        </>
    )
}

export default SideBar;